import {
  AFS_GROUP,
  BONDS_GROUP,
  GROUP_ASSET_NAME,
  HTM_GROUP,
} from '../../../state/app/constants';

export const PLAYER_BOND_GROUPS = [BONDS_GROUP, AFS_GROUP, HTM_GROUP];

export const getPlayerAllocationGroupName = (assetGroup: number) =>
  PLAYER_BOND_GROUPS.includes(assetGroup)
    ? 'Bonds'
    : GROUP_ASSET_NAME[assetGroup];

type AllocationLimits = {
  asset_group: number;
  lower_limit: number;
  upper_limit: number;
};

export const getCombinedAllocationLimits = (
  allocations: AllocationLimits[],
  assetGroups: number[],
) => {
  const uniqueAssetGroups = Array.from(new Set(assetGroups));
  if (uniqueAssetGroups.length === 0) {
    return undefined;
  }

  const applicableAllocations = uniqueAssetGroups.map(assetGroup =>
    allocations.find(allocation => allocation.asset_group === assetGroup),
  );
  if (applicableAllocations.some(allocation => allocation === undefined)) {
    return undefined;
  }

  return applicableAllocations.reduce(
    (combined, allocation) => ({
      lower_limit: combined.lower_limit + allocation!.lower_limit,
      upper_limit: combined.upper_limit + allocation!.upper_limit,
    }),
    { lower_limit: 0, upper_limit: 0 },
  );
};
